export function setSessionItem (key, value) {
  try {
    sessionStorage.setItem(key, value)
  } catch (_) {
    // iframe storage can be blocked; fall back to URL params only
  }
}

export function getSessionItem (key) {
  try {
    return sessionStorage.getItem(key)
  } catch (_) {
    return null
  }
}
